import createEmptyWebhookRow from "./createEmptyWebhookRow";
import type { ISavedSearchWebhookTableRow } from "../types/webhook";

export const withIndex = (
    rows: readonly Omit<ISavedSearchWebhookTableRow, "index" | "isDeleteDisabled">[],
): ISavedSearchWebhookTableRow[] => {
    return rows.map((row, index) => ({
        ...row,
        index,
        isDeleteDisabled: !!row.id && rows.length === 1,
    }));
};

export default function webhookRowsTransformer(
    rows: readonly Omit<ISavedSearchWebhookTableRow, "index" | "isDeleteDisabled">[],
): ISavedSearchWebhookTableRow[] {
    if (rows.length) {
        return withIndex(rows);
    }

    return withIndex([createEmptyWebhookRow()]);
}
